import { Component } from '@angular/core';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';

@Component({
    selector: 'gl-payment-api-success-popup',
    templateUrl: './payment-api-success-popup.component.html',
    styleUrls: ['./payment-api-success-popup.component.scss'],
    standalone: false
})
export class PaymentApiSuccessPopupComponent {
  constructor(private modalRef: ModalOverlayRef) {
    this.modalRef.backgroundClicked();
  }

  public close(result: boolean) {
    this.modalRef.close(result);
  }
}
